export const WATERMARK_DIMENSION = 150;
export const WATERMARK_SRC = 'https://pastatic.picsart.com/91671767329821691916.svg';
export const WATERMARK_OFFSET = 35;
